import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const ciscoThreatGrid = defineConnector({
  identifier: "ciscoThreatGrid",
  name: "Cisco Threat Grid",
  tagLine: "Malware analysis and threat intelligence",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ portalUrl }) =>
    urlToPattern(
      `${portalUrl || "https://panacea.threatgrid.com"}/api`,
      "https://([a-z0-9-]+\\.)?threatgrid\\.com/api/.*"
    ),
  auth: (app) => queryAuth([{ name: "api_key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create an API key in Threat Grid",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to the [Threat Grid dashboard](https://panacea.threatgrid.com/), open **My Account**, and copy the API key.",
        },
      ],
    },
    {
      title: "Enter your Threat Grid details",
      items: [
        {
          kind: "url",
          label: "Portal URL",
          placeholder: "https://panacea.threatgrid.com",
          required: true,
          helperText:
            "Use your regional cloud or appliance URL if you do not use `panacea.threatgrid.com`.",
          target: { kind: "configuration", field: "portalUrl" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          helperText: "Paste the API key from **My Account**.",
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ portalUrl }) =>
      `${portalUrl || "https://panacea.threatgrid.com"}/api/v3/session/whoami`,
  },
});
